import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: 'center',
  '& .FSSRemaintime': {
    color: theme.palette.primary.main,
    padding: theme.spacing(1),
    width: theme.spacing(6),
    display: ' inline-block',
    position: 'relative',
    '&:not(:last-child)': {
      marginRight: theme.spacing(2),
      '& .FSSSeparetor': {
        '&:after': {
          content: '":"',
          position: 'absolute',
          right: theme.spacing(-1.5),
          color: theme.palette.common.white,
          width: theme.typography.pxToRem(7),
        },
      },
    },
    '& .FSSSeparetor': {
      display: 'inline',
    },

    '& .FSSLabel': {
      color: theme.palette.common.white,
    },
   
  },
   '&.FSSDisabled': {
     color: theme.palette.text.disabled,
      '& .FSSRemaintime': {
        color: theme.palette.text.disabled,
        '& .FSSSeparetor': {
          '&:after': {
            color: theme.palette.text.disabled,
          },
        },
        '& .FSSLabel': {
          color: theme.palette.text.disabled,
        },
      },
    },
}));
export default StyledBox;
